(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axia-collections-hero"] && !Shopify.designMode) return;
  try {
    
  const initAxiaCollectionsNavigation = () => {
    document.querySelectorAll('[data-axia-hero]').forEach((hero) => {
      if (hero.dataset.axiaNavReady === 'true') return;

      const nav = hero.querySelector('[data-axia-nav]');
      const next = hero.querySelector('[data-axia-next]');
      const stories = Array.from(document.querySelectorAll('[data-axia-story]'));
      if (!nav || stories.length === 0) return;

      hero.dataset.axiaNavReady = 'true';

      const targets = [hero, ...stories];
      const list = document.createElement('ol');
      list.className = 'axia-collections-nav__list';

      targets.forEach((target, index) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        const number = String(index).padStart(2, '0');
        const targetName = target.dataset.navName || number;

        link.className = 'axia-collections-nav__link';
        link.href = `#${target.id}`;
        link.textContent = number;
        link.setAttribute('aria-label', targetName);
        if (index === 0) link.setAttribute('aria-current', 'true');

        item.appendChild(link);
        list.appendChild(item);
      });

      nav.replaceChildren(list);
      next.href = `#${stories[0].id}`;

      const links = Array.from(list.querySelectorAll('a'));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => {
              if (link.getAttribute('href') === `#${entry.target.id}`) {
                link.setAttribute('aria-current', 'true');
              } else {
                link.removeAttribute('aria-current');
              }
            });
          });
        },
        { threshold: 0.55 }
      );

      targets.forEach((target) => observer.observe(target));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAxiaCollectionsNavigation, { once: true });
  } else {
    initAxiaCollectionsNavigation();
  }

  document.addEventListener('shopify:section:load', initAxiaCollectionsNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axia-service-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var held = 'is-held';
    function release() {
      document.querySelectorAll('.axia-service-strip.is-held').forEach(function (el) { el.classList.remove(held); });
    }
    document.addEventListener('pointerdown', function (event) {
      var strip = event.target.closest && event.target.closest('.axia-service-strip');
      if (strip) strip.classList.add(held);
    }, { passive: true });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'blur'].forEach(function (name) {
      document.addEventListener(name, release, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
